<script setup lang="ts"></script>

<template>
  <div>OK</div>
</template>
